export default {
  SHOW_MORE_SAVED_SEARCHES_CLICKED: 'Show more saved searches clicked',
  SHOW_LESS_SAVED_SEARCHES_CLICKED: 'Show less saved searches clicked',
  ORGANIZATION_SAVED_SEARCH_CREATED: 'Organization saved search created',
  USER_SAVED_SEARCH_CREATED: 'User saved search created'
};
